export const campaignListPageStyles = {
  topDivider: {
    height: 2,
    margin: '0 -14px 6px',
    background: 'linear-gradient(90deg, rgba(111,115,246,0.46) 0%, rgba(111,115,246,0.18) 56%, rgba(111,115,246,0) 100%)',
  } as const,
  introCard: {
    padding: '4px 2px 2px',
  } as const,
  introTopRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
  } as const,
  centerCaption: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 7,
    fontSize: 14,
    lineHeight: 1.2,
    fontWeight: 800,
    color: '#6d74f3',
  } as const,
  centerCaptionBar: {
    width: 4,
    height: 20,
    borderRadius: 999,
    background: 'linear-gradient(180deg, #6d74f3 0%, #8e7ef7 100%)',
    boxShadow: '0 4px 8px rgba(111, 115, 246, 0.18)',
  } as const,
  introCountPill: {
    padding: '6px 10px',
    borderRadius: 999,
    background: '#f2f3fb',
    color: '#7b82a8',
    fontSize: 11,
    lineHeight: 1.2,
    fontWeight: 700,
  } as const,
  introTitle: {
    marginTop: 10,
    fontSize: 22,
    lineHeight: 1.14,
    color: '#17181f',
    fontWeight: 800,
    letterSpacing: '-0.03em',
  } as const,
  introSubtitleRow: {
    marginTop: 10,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
  } as const,
  introSubtitleIcon: {
    color: '#949aad',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as const,
  introSubtitle: {
    fontSize: 12,
    lineHeight: 1.4,
    color: '#8b92a4',
    fontWeight: 600,
  } as const,
  cardMeta: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 10,
  } as const,
  titleBlock: {
    minWidth: 0,
    flex: 1,
  } as const,
  campaignCard: {
    padding: '16px 14px 14px',
    borderRadius: 18,
    background: '#ffffff',
    border: '1px solid rgba(232, 236, 244, 0.96)',
    boxShadow: '0 10px 22px rgba(82, 88, 110, 0.07)',
  } as const,
  campaignTitle: {
    fontSize: 17,
    lineHeight: 1.2,
    fontWeight: 800,
    color: '#1c1f28',
    letterSpacing: '-0.03em',
  } as const,
  statusPill: {
    flexShrink: 0,
    padding: '5px 10px',
    borderRadius: 999,
    fontSize: 11,
    lineHeight: 1.2,
    fontWeight: 800,
    border: '1px solid transparent',
  } as const,
  statusPillLavender: {
    background: '#f3f0ff',
    color: '#6f74f5',
    borderColor: '#ebe6ff',
  } as const,
  statusPillIndigo: {
    background: '#eef1ff',
    color: '#5b65ee',
    borderColor: '#dde3ff',
  } as const,
  statusPillViolet: {
    background: '#f1efff',
    color: '#7b68f4',
    borderColor: '#e7e1ff',
  } as const,
  metaGroup: {
    marginTop: 12,
    display: 'grid',
    gap: 5,
  } as const,
  metaRow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    fontSize: 12,
    lineHeight: 1.4,
    color: '#868ea1',
    fontWeight: 700,
  } as const,
  metaIcon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#989fb1',
    flexShrink: 0,
  } as const,
  descriptionBox: {
    marginTop: 14,
    borderRadius: 14,
    background: '#f6f7fb',
    border: '1px solid rgba(233, 236, 243, 0.96)',
    padding: '14px 12px',
  } as const,
  description: {
    fontSize: 13,
    lineHeight: 1.58,
    color: '#515766',
    fontWeight: 600,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 3,
    overflow: 'hidden',
  } as const,
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginTop: 14,
  } as const,
  footerHint: {
    fontSize: 12,
    lineHeight: 1.4,
    color: '#7d8496',
    flex: 1,
    fontWeight: 700,
  } as const,
  primaryButton: {
    minWidth: 112,
    height: 42,
    padding: '0 22px',
    fontSize: 14,
    fontWeight: 800,
    color: '#ffffff',
    background: 'linear-gradient(90deg, #6d74f3 0%, #5865f0 100%)',
    border: '1px solid rgba(101, 109, 240, 0.96)',
    boxShadow: '0 8px 18px rgba(95, 102, 246, 0.22)',
  } as const,
  secondaryButton: {
    minWidth: 112,
    height: 42,
    padding: '0 22px',
    fontSize: 14,
    fontWeight: 800,
    color: '#8d95a6',
    background: '#f7f8fb',
    border: '1px solid rgba(224, 229, 238, 0.95)',
    boxShadow: 'none',
  } as const,
};
